export const PATHNAMES = {
  loginPath: "/login",
  usersPath: "/users",
  nomenclaturePath: "/nomenclature",
  ordersPath: "/orders",
  remainsPath: "/remains",
  reportsPath: "/reports",
  reportDraftPath: "/reports/draft",
  cartPath: "/cart",
  skadUsersPath: "skad-employees",
  dealerUsersPath: "dealer-users",
  dealerPath: "dealers",
  profilePath: "profile",
  recoveryPassPath: "/recoverypass",
  branchesPath: "branches",
  notificationPath: "mailing-notifications",
  settingsPath: "/settings",
  settingsSectionsPath: {
    categories: "categories",
    marginality: "marginality",
    recommendation: "recommendation",
    acceptDate: "acceptDate",
    figureStatus: "figureStatus",
    monitoring: "monitoring",
    stockPublication: "stockPublication",
  },
  accountsReceivablePath: "/accountsReceivable",
  cookiePage: "/policy/cookies-policy/",
  faqPath: {
    root: "/faq/",
    dealer: "/faq/dealer/",
    manager: "/faq/manager/",
    dealerSearch: "/faq/dealer/search",
    managerSearch: "/faq/manager/search",
    nomenclature: "nomenclature",
    orders: "order",
    remains: "remains",
    reports: "report",
    cart: "basket",
    dealers: "dealers",
    settings: "options",
  },
};
